<template>
  <div>
    <el-dialog class="verify-modal-wrapper" :custom-class="'verify-dialog'" :close-on-click-modal="false"
      :visible.sync="showModal" title="拖动下方滑块完成验证" width="520px" :before-close="handleClose">
      <div id="captcha-element"></div>
      <div slot="footer"></div>
    </el-dialog>
  </div>
</template>

<script>
  import '@/utils/AliyunCaptcha'
export default {
  name: 'VerifyModal',
  props: {
    id: {
      type: String,
      default: 'captcha-button'   // 触发按钮id
    }
  },
  data() {
    return {
      showModal: false,
      captcha: null
    }
  },
  beforeDestroy() {
    const mask = document.getElementById('aliyunCaptcha-mask')
    if (mask) mask.remove()

    const popup = document.getElementById('aliyunCaptcha-window-popup')
    if (popup) popup.remove()
  },
  methods: {

    invokeModal() {
      this.showModal = true
      this.$nextTick(() => {
        this.initAliyunCaptcha()
      })
    },

    initAliyunCaptcha() {
      window.initAliyunCaptcha({
        SceneId: 'voivr79l',      
        prefix: '1xzopt',      
        mode: 'embed',
        element: '#captcha-element',
        button: `#${this.id}`,
        immediate: true,

        captchaVerifyCallback: this.captchaVerifyCallback,
        onBizResultCallback: this.onBizResultCallback,
        getInstance: this.getInstance,

        slideStyle: {
          width: 350,
          height: 40
        },
        language: 'cn'
      })
    },

    getInstance(instance) {
      this.captcha = instance
    },

    // 验证成功后，阿里云返回的参数
    captchaVerifyCallback(captchaVerifyParam) {
      let params = {
        captchaVerifyParam:captchaVerifyParam,
        sceneId:'voivr79l'
      }
      console.log('captchaVerifyParam',params)
      this.$emit('success', params)
      return {
        captchaResult: true,
        bizResult: true
      }
    },

    onBizResultCallback() {
      this.showModal = false
    },

    handleClose() {
      this.showModal = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/VerifyModal.vue